// extracted by mini-css-extract-plugin
module.exports = {"overlay":"modal_full_screen-module--overlay--1jnc3","container":"modal_full_screen-module--container--25cd9","noBodyScroll":"modal_full_screen-module--noBodyScroll--2GFRb"};